/** Подпись счётчика избранного в шапке и мобильной панели: список в store остаётся полным. */
export function formatFavoriteCount(favorite) {
    const count = favorite && typeof favorite === 'object' ? Object.keys(favorite).length : 0;
    return count > 99 ? '99+' : count;
}
